import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const StyleWrapper = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999999;

    :before {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: block;
        content: '';
        background-color: rgba(0, 0, 0, 0.5);
    }
    
    .loader-container {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .ripple-effect {
        display: inline-block;
        position: relative;
        width: 64px;
        height: 64px;
      }
      .ripple-effect div {
        position: absolute;
        top: 50%;
        left: 50%;
        border: 4px solid #fff;
        opacity: 1;
        border-radius: 50%;
        animation: ripple-effect 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
        transform: translate(-50%, -50%);
      }
      .ripple-effect div:nth-child(2) {
        animation-delay: -0.5s;
      }
      @keyframes ripple-effect {
        0% {
          width: 0;
          height: 0;
          opacity: 1;
        }
        100% {
          width: 58px;
          height: 58px;
          opacity: 0;
        }
      }
      
`;
export default WithDirection(StyleWrapper);


// WEBPACK FOOTER //
// ./src/components/OverlayLoading/Wrapper.js